import gql from 'graphql-tag'

const userError = gql`
  fragment userError on UserError {
    key
    message
    code
  }
`

export default userError
